var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "c-media-gallery" }, [
        _c("div", { staticClass: "c-media-gallery--mediawrapper" }, [
          _c("div", { staticClass: "c-media-gallery--modaltoggle" }, [
            _c(
              "div",
              {
                staticClass: "c-media-gallery--button",
                on: {
                  click: function($event) {
                    return _vm.handleModalOpen()
                  }
                }
              },
              [_c("v-icon", { attrs: { name: "icon-minimize", size: "xs" } })],
              1
            )
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: _vm.currentImage.url, alt: _vm.currentImage.alt }
          })
        ]),
        _vm._v(" "),
        _vm.currentImage.caption
          ? _c("div", { staticClass: "c-media-gallery--caption" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.currentImage.caption) +
                  "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-media-gallery--thumbnails" },
          _vm._l(_vm.listItems, function(mediaItem, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "c-media-gallery--thumbnail",
                class: { active: _vm.activeIndex === index },
                on: {
                  click: function($event) {
                    _vm.activeIndex = index
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "c-media-gallery--thumbnailwrapper" },
                  [_c("img", { attrs: { src: mediaItem.thumbnail } })]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.showPagination
          ? _c(
              "div",
              {
                staticClass: "c-media-gallery--showmore",
                on: {
                  click: function($event) {
                    _vm.showAllImages = true
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.showMore) + " (" + _vm._s(_vm.itemCount) + ")"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _c("v-icon", {
                      attrs: { name: "icon-chevron", cssModifiers: "icon" }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showModal
        ? _c("v-media-gallery-modal", {
            attrs: { items: _vm.items, currentParentIndex: _vm.activeIndex },
            on: { onClose: _vm.handleModalClose }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }